import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IRootState} from "../../store/store";
import {selectIsUserAuthenticated} from "../../user/utils/select_is_user_authenticated";
import {IHomematchPreleadListResponse} from "../types/IHomematchPrelead";

export interface IHomematchPreleadsResult {
    response: IHomematchPreleadListResponse | null;
    /** False when the portal is gated off (403 `hmt_not_available_for_site`) or the user is anonymous. */
    isAvailable: boolean;
    /** Seconds after which a cold-start 503 asks to be retried (`Retry-After`). */
    retryAfterSeconds: number | null;
}

const UNAVAILABLE_RESULT: IHomematchPreleadsResult = {response: null, isAvailable: false, retryAfterSeconds: null};

/**
 * Homematch tinder buffer for the "Mieszkania wybrane dla Ciebie" teaser
 * The endpoint distinguishes three non-data outcomes the teaser must
 * survive quietly: 403 `hmt_not_available_for_site` (kill switch for RP), 503
 * with `Retry-After` (buffer cold start), and plain errors — none of them may
 * break the homepage, so every branch resolves to a regular result object.
 */
export const getHomematchPreleadsApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getHomematchPreleads: builder.query<IHomematchPreleadsResult, void>({
            queryFn: async (_arg, queryApi, _extraOptions, baseQuery) => {
                if (!selectIsUserAuthenticated(queryApi.getState() as IRootState)) {
                    return {data: UNAVAILABLE_RESULT};
                }

                const result = await baseQuery({url: apiUserLink.homeMatch.preleads});

                if (result.error) {
                    if (result.error.status === 403) {
                        return {data: UNAVAILABLE_RESULT};
                    }

                    if (result.error.status === 503) {
                        const retryAfterSeconds = parseRetryAfterSeconds(result.meta?.response?.headers?.get("Retry-After"));

                        return {data: {response: null, isAvailable: true, retryAfterSeconds}};
                    }

                    return {data: {response: null, isAvailable: true, retryAfterSeconds: null}};
                }

                return {data: {response: result.data as IHomematchPreleadListResponse, isAvailable: true, retryAfterSeconds: null}};
            },
            providesTags: ["HomematchPreleads"]
        })
    }),
    overrideExisting: false
});

/** "Retry-After" is documented as delta-seconds here; anything else means "do not retry". */
export const parseRetryAfterSeconds = (headerValue: string | null | undefined): number | null => {
    const seconds = Number(headerValue);

    return Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds) : null;
};

export const {useGetHomematchPreleadsQuery} = getHomematchPreleadsApi;
import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IRootState} from "../../store/store";
import {selectIsUserAuthenticated} from "../../user/utils/select_is_user_authenticated";
import {IHomematchPreleadListResponse} from "../types/IHomematchPrelead";

export interface IHomematchPreleadsResult {
    response: IHomematchPreleadListResponse | null;
    /** False when the portal is gated off (403 `hmt_not_available_for_site`) or the user is anonymous. */
    isAvailable: boolean;
    /** Seconds after which a cold-start 503 asks to be retried (`Retry-After`). */
    retryAfterSeconds: number | null;
}

const UNAVAILABLE_RESULT: IHomematchPreleadsResult = {response: null, isAvailable: false, retryAfterSeconds: null};

/**
 * Homematch tinder buffer for the "Mieszkania wybrane dla Ciebie" teaser
 * The endpoint distinguishes three non-data outcomes the teaser must
 * survive quietly: 403 `hmt_not_available_for_site` (kill switch for RP), 503
 * with `Retry-After` (buffer cold start), and plain errors — none of them may
 * break the homepage, so every branch resolves to a regular result object.
 */
export const getHomematchPreleadsApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getHomematchPreleads: builder.query<IHomematchPreleadsResult, void>({
            queryFn: async (_arg, queryApi, _extraOptions, baseQuery) => {
                if (!selectIsUserAuthenticated(queryApi.getState() as IRootState)) {
                    return {data: UNAVAILABLE_RESULT};
                }

                const result = await baseQuery({url: apiUserLink.homeMatch.preleads});

                if (result.error) {
                    if (result.error.status === 403) {
                        return {data: UNAVAILABLE_RESULT};
                    }

                    if (result.error.status === 503) {
                        const retryAfterSeconds = parseRetryAfterSeconds(result.meta?.response?.headers?.get("Retry-After"));

                        return {data: {response: null, isAvailable: true, retryAfterSeconds}};
                    }

                    return {data: {response: null, isAvailable: true, retryAfterSeconds: null}};
                }

                return {data: {response: result.data as IHomematchPreleadListResponse, isAvailable: true, retryAfterSeconds: null}};
            },
            providesTags: ["HomematchPreleads"]
        })
    }),
    overrideExisting: false
});

/** "Retry-After" is documented as delta-seconds here; anything else means "do not retry". */
export const parseRetryAfterSeconds = (headerValue: string | null | undefined): number | null => {
    const seconds = Number(headerValue);

    return Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds) : null;
};

export const {useGetHomematchPreleadsQuery} = getHomematchPreleadsApi;
